import { render, staticRenderFns } from "./AcceptPaymentMethods.vue?vue&type=template&id=c212a618"
import script from "./AcceptPaymentMethods.vue?vue&type=script&lang=js"
export * from "./AcceptPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports